module.exports = import("https://cdn.socket.io/4.4.1/socket.io.esm.min.js");;